<p-dialog
  [(visible)]="visible"
  [closable]="false"
  [showHeader]="false"
  [dismissableMask]="false"
  [baseZIndex]="39000"
  class="ss-l-dialog dialog-loading">
  
  <div class="text-center px-3 py-2">
    <div class="text-xl font-semibold">Aguarde ...</div>
    <p-progressBar mode="indeterminate" class="ss-l-bar mt-3"></p-progressBar>
  </div>
  
</p-dialog>